<template>
  <div
    style="
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      height: 100%;
      min-height: 62px;
    "
  >
    <div>
      {{ formatCreatedAt(item.createdAt) }}
    </div>
    <div>
      {{ item.createdByName !== 'parent' ? `Tạo bởi ${item.createdByName}` : 'Phụ huynh đăng ký' }}
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    item: Object
  },
  methods: {
    formatCreatedAt(date) {
      return moment(date).format('DD/MM/YYYY')
    }
  }
}
</script>
